export const ListQueryKey = 'signRecords';
export const DetailQueryKey = 'signRecord';

export const Urls = {
  selectUrl: '/signRecord/list',
  updateUrl: '/signRecord/update',
  deleteUrl: '/signRecord/delete',
  createUrl: '/signRecord/create',
  detailUrl: '/signRecord/detail',
};
